import { render, staticRenderFns } from "./StatisticsTradeTurnoverP2PChart.vue?vue&type=template&id=4aa830c0&scoped=true&"
import script from "./StatisticsTradeTurnoverP2PChart.vue?vue&type=script&lang=js&"
export * from "./StatisticsTradeTurnoverP2PChart.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTradeTurnoverP2PChart.vue?vue&type=style&index=0&id=4aa830c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa830c0",
  null
  
)

export default component.exports